import { useEffect, useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseSupplierRequest } from "./UseSupplierRequest";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";
import SearchComProduct from "../../products/relatedProduct/SearchComProduct";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

export default function AddRequest() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [request, setRequest] = useState();
  const [expireDate, setExpireDate] = useState();
  const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"];
  const { validate, addRequest } = UseSupplierRequest();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    productID: undefined,
    expiredate: undefined,
    requestCount: undefined,
  });

  const [errorState, setErrorState] = useState({
    productID: false,
    expiredate: false,
    requestCount: false,
  });

  useEffect(() => {
    let newValueStart = expireDate?.toDate?.().toLocaleDateString("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });

    setState({ ...state, expiredate: newValueStart });
  }, [expireDate]);

  return (
    <Detail
      breadChilds={{
        title: "بازرگانی",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/supplierrequest" },
          { name: "درخواست جدید", url: "/supplierrequest/addRequest" },
        ],
      }}
    >
      {!request ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 7"}>
            <SearchComProduct
              supplierRequest
              productID={state.productID}
              productModel={state}
              setProductModel={setState}
              errorState={errorState.productID}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 5"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <DatePicker
              weekDays={weekDays}
              calendar={persian}
              locale={persian_fa}
              format="YYYY-MM-DD"
              value={expireDate}
              onChange={setExpireDate}
              containerStyle={{
                width: "100%",
              }}
              render={
                <TextField
                  error={errorState.expiredate}
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  size="small"
                  fullWidth
                  label="مهلت ارائه پیشنهاد"
                />
              }
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.requestCount ? state.requestCount : ""}
              error={errorState.requestCount}
              label="تعداد درخواست"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, requestCount: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{
                input: { direction: "rtl" },
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end" }}
            gridColumn="span 3"
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  addRequest(state, () => {
                    setMsGotoLast(true);
                    navigate("/supplierrequest", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/supplierrequest", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
